<template>
  <div class="question-list">
    <common-card card-title="问题列表">
      <div class="question-container-warpper">
        <el-row :gutter="40" type="flex">
          <el-col
            v-for="(item, index) in userDetailQuestionList"
            :key="index"
            :span="6"
          >
            <div class="title">{{ index }}</div>
            <div class="answer">{{ item }}</div>
          </el-col>
        </el-row>
      </div>
    </common-card>
  </div>
</template>

<script>
import CommonCard from '@/components/CommonCard'
import { mapGetters } from 'vuex'
export default {
  name: 'QuestionList',
  components: {
    CommonCard
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['userDetailQuestionList'])
  }
}
</script>

<style lang="scss" scoped>
.question-list {
  margin-top: 1.2rem;
  font-size: 12px;
  .question-container-warpper{
    margin-left:18px;
    margin-bottom: 10px;
    .title{
      margin-top: 20px;
      font-weight: bold;
    }
    .answer{
      margin-top: 18px;
      line-height: 18px;
      margin-bottom: 15px;
    }
  }
}
</style>

